<template>
  <div class="pr-0 pr-md-3 d-flex" style="align-items: center; flex-flow: row wrap">
      <span class="my-2 my-sm-0 d-none d-md-inline-block text-info" style="position: relative; left: 32px;">
        <font-awesome-icon :icon="['fa', 'search']" v-if="searchesInProgress == 0"/>
        <font-awesome-icon spin :icon="['fa', 'spinner']" v-else/>
      </span>

      <div style="position: relative; width: 0px; height: 0px">
        <div style="position: absolute; z-index: 10000; left:4px; top:20px; width: 400px" v-if="showSearchList">

          <div v-if="actionsEmpty" class="list-group">
            <span class="list-group-item list-group-item-action small"> <i> {{$tr('noResultFound','No results found')}} </i></span>
          </div>

          <div class="list-group small"
               ref="actionsList"
               v-else>
            <div :class="'list-group-item smart-search-item' + (selectedId == action.id ? ' active' : '') "  v-for="action in actions"
                 :key="action.id"
                 tabindex="0"
                 @mouseover="selectedId = action.id "
                 :data-action-id="action.id" @click="execute(action.id)"
            >
                <font-awesome-layers>
                  <font-awesome-icon v-if="action.iconModifier"  transform="shrink-3 left-3 up-3" :icon="action.icon"></font-awesome-icon>
                  <font-awesome-icon v-else :icon="action.icon"></font-awesome-icon>
                  <font-awesome-icon v-if="action.iconModifier" transform="shrink-5 right-6 down-6" :icon="action.iconModifier"></font-awesome-icon>
                </font-awesome-layers>
                <span class="pl-1" v-html="action.filledLabel"></span>
                <small v-if="action.type == 'bot'">{{$tr('chatWithSilena','Chat with Silena')}}</small>
            </div>
          </div>
        </div>
      </div>

      <b-form-input class="mr-1 ml-1"
                    autocomplete="off"
                    ref="queryInput"
                    style="min-width: 254px; padding-left: 42px"
                    :placeholder="$tr('searchFor','Search for...')"
                    v-model="searchInput"
                    @keypress="searchChanged"
                    @keydown.stop="kDown"
                    @focusout="hideSearch($event, true)"
                    data-test-path="smart-search"
      ></b-form-input>
  </div>

</template>

<script>
import Rpc from "@/Rpc";
import _ from "lodash";
import FormsAI from "@/components/forms/FormsAI";
import {HotKeys, KeyPattern} from "@/utils/HotKeys";
import {startChatBot, startChatBotFromSearch} from "@/components/chatBot/ChatBotTools";
import fillActionWithData, {executeAction} from "@/components/dashboard/SmartActions";


export default {
  name: "SmartSearch",
  created() {
    this.pendingTimer = null;
    this.lastQuery = null;
  },
  mounted() {
    HotKeys.register(new KeyPattern("k", true, false, true), () => {
      this.$refs.queryInput.$el.focus();
    });
  },
  methods: {

    execute(actionId) {

      for (let i = 0; i < this.actions.length; i++) {
        if (this.actions[i].id === parseInt(actionId)) {
          Rpc.Actions.reportActionHit(this.actions[i].requestUUID, actionId).then();
          if(this.actions[i].type == "bot"){
            this.actions[i].query = this.lastQuery;
            startChatBotFromSearch(this.actions[i].botUUID, this.actions[i]);
          } else {
            executeAction(this.actions[i]);
          }
          break;
        }
      }

      this.showSearchList = false;
      this.searchInput = "";
    },
    onDownArrow(){
      if(!this.showSearchList || this.selectedId === null || this.selectedId === undefined){
        return;
      }
      let goToNext = false;
      for (let i = 0; i < this.actions.length; i++) {
        if(goToNext){
          this.selectedId = this.actions[i].id;
          let posStart = this.$refs.queryInput.selectionStart;
          let posEnd = this.$refs.queryInput.selectionEnd;
          setTimeout(()=>{
            this.$refs.queryInput.selectionStart = posStart;
            this.$refs.queryInput.selectionEnd = posEnd;
          });
          break;
        }

        if (this.actions[i].id == this.selectedId) {
          goToNext = true;
        }
      }
      return;
    },
    onUpArrow(){
      if(!this.showSearchList || this.selectedId === null || this.selectedId === undefined){
        return;
      }
      let prevId = -1;
      for (let i = 0; i < this.actions.length; i++) {
        if (this.actions[i].id == this.selectedId) {
          if(i>0){
            this.selectedId = prevId;
          }
          let posStart = this.$refs.queryInput.selectionStart;
          let posEnd = this.$refs.queryInput.selectionEnd;
          setTimeout(()=>{
            this.$refs.queryInput.selectionStart = posStart;
            this.$refs.queryInput.selectionEnd = posEnd;
          });
          break;
        }
        prevId = this.actions[i].id;
      }
      return;
    },
    kDown(ev){
      if (ev.key == "ArrowDown") {
        this.onDownArrow();
        ev.stopImmediatePropagation();
        ev.stopPropagation();
        return false;
      }
      if (ev.key == "ArrowUp") {
        this.onUpArrow();
        ev.stopImmediatePropagation();
        ev.stopPropagation();
        return false;
      }
      let key = ev.keyCode || ev.charCode;
      if( key == 8 || key == 46 ) {
        this.searchChanged({key:{code:"Backspace"}});
      }
      if( key == 27 ) {
        this.hideSearch();
      }
      if( key == 46 ) {
        this.searchChanged({key:{code:"Del"}});
      }


    },
    searchChanged(key) {
      if (key.code == "ArrowUp" || key.code == "ArrowDown" ) {
          return;
      }
      if (key.code == "Enter") {
        if(this.showSearchList && this.selectedId){
          this.execute(this.selectedId);
          return;
        }

        this.runImmediatelly = true;
        this.executeQuery();
        return false;
      }
      this.runImmediatelly = false;
      this.hideSearch();
      if (this.pendingTimer) {
        clearTimeout(this.pendingTimer);
        this.pendingTimer = null;
      }

      this.pendingTimer = setTimeout(() => {
        this.executeQuery();
        clearTimeout(this.pendingTimer);
        this.pendingTimer = null;
      }, 1000);
    },

    searchClicked() {
      clearTimeout(this.pendingTimer);
      this.pendingTimer = null;
      this.executeQuery();
    },

    executeQuery(inp) {
      inp = inp || this.searchInput
      this.queryInProgress = true;
      this.lastQuery = inp
      if (this.searchInput.length < 2) {
        this.procQueryResult([]);
        return;
      }

      this.searchesInProgress += 1;
      Rpc.Actions.findAction(this.lastQuery).then(async (res) => {
        this.searchesInProgress -= 1;
        if (this.lastQuery == inp) {
          let logTable = [];
          res.forEach(async a => {
            await this.processEntry(a);
            logTable.push(a.filledLabel + " (" + a.weight + ")");
          });


          this.actionsEmpty = (res.length == 0);
          if(!this.actionsEmpty){
            this.selectedId = res[0].id;
          }

          this.actions = res;
          if(this.runImmediatelly && !this.actionsEmpty){
            this.execute(res[0].id);
            return;
          }

          this.showSearchList = true;
        }
      }).catch(e => {
        Log.fatal("Search failed:" + JSON.stringify(e));
        this.searchesInProgress -= 1;
        this.actions = [];
        this.showSearchList = true;
        this.actionsEmpty = (this.actions.length == 0);
      });
    },
    procQueryResult() {
    },
    hideSearch(event, cleanInput) {
      if (event) {
        let target = event.relatedTarget;

        if (target === this.$refs["goLink"]) {
          return;
        }
        if (target && target.dataset && target.dataset.actionId || (this.$refs.actionsList?.contains(target))) {
            return;
        }
      }
      window.requestAnimationFrame(() => {
        this.showSearchList = false;
        if (cleanInput) {
          this.searchInput = "";
        }
      });
    },
    /**
     * @param {ActionCall} a
     */
    async processEntry(a) {
      await fillActionWithData(a);
    }
  },
  props: {
    // fileSelected: Function,
    // allowNewUpload: {type: Boolean, default:true}
  },
  data: function () {
    return {
      searchInput: "",
      selectedId: null,
      queryInProgress: false,
      runImmediatelly: false,
      ctr: 0,
      showSearchList: true,
      actions: [],
      actionsEmpty: false,
      searchesInProgress: 0
      // progress: 0
    }
  }
}
</script>
